window.editorjs = {};
import EditorJS from '@editorjs/editorjs';
window.editorjs.EditorJS = EditorJS;
import Header from '@editorjs/header'; 
window.editorjs.Header = Header;
import List from '@editorjs/list'; 
window.editorjs.List = List;
import Table from 'editorjs-table'; 
window.editorjs.Table = Table;
import Marker from '@editorjs/marker'; 
window.editorjs.Marker = Marker;
import Delimiter from '@editorjs/delimiter'; 
window.editorjs.Delimiter = Delimiter;
import edjsHTML from 'editorjs-html'; 
window.editorjs.edjsHTML = edjsHTML;
import Undo from 'editorjs-undo';
window.editorjs.Undo = Undo;
import ImageTool from '@editorjs/image';
// window.editorjs.ImageTool = ImageTool;
import Paragraph from 'editorjs-paragraph-with-alignment';
window.editorjs.Paragraph = Paragraph;
import Underline from '@editorjs/underline';
window.editorjs.Underline = Underline;
import Layout from 'editorjs-layout';
window.editorjs.Layout = Layout;
import RawTool from '@editorjs/raw';
window.editorjs.RawTool = RawTool;
import NestedList from '@editorjs/nested-list';
window.editorjs.NestedList = NestedList;


window.tableParser = function tableParser(block){
  console.log("TABLE", block.data.content);
  var _html = '<table>';
  block.data.content.forEach(row => {
    _html = _html + "<tr>";
    row.forEach(cell => {
      _html = _html + '<td>'+cell+'</td>';
    });
    _html = _html + "</tr>";
  });
  _html = _html+'</table>';
  return _html;
}
// window.nestedListParser = function nestedListParser(block){
//   console.log("nestedListParser", block);
//   console.log("nestedListParser", block.data);
  
//   return '<br/>';
// }

class NarrowImageTool extends ImageTool {

  static get toolbox() {
    return {
      icon: "<i class='far fa-columns'/>",
      title: 'Image in Columns',
    };
  }

  render(toolData) {
    var w = $(this.ui.nodes.wrapper);
    w.addClass('width_half');
    return this.ui.render(this.data);
  }
}
window.editorjs.NarrowImageTool = NarrowImageTool;


class ImageTool2 extends ImageTool {
  render(toolData) {
    if (window.imageInThirds && window.imageInThirds.includes(this.data.file.url)) {
      this.setTune('widthThird',true);
    }
    if (window.imageInHalves && window.imageInHalves.includes(this.data.file.url)) {
      this.setTune('widthHalf',true);
    }
    return this.ui.render(this.data);
  }
}
window.editorjs.ImageTool2 = ImageTool2;


class SimpleImage {
  constructor(){
    this.data = data;
    this.wrapper = undefined;
  }

  // ... previously added methods

  renderSettings(){
    const settings = [
      {
        name: 'withBorder',
        icon: `<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M15.8 10.592v2.043h2.35v2.138H15.8v2.232h-2.25v-2.232h-2.4v-2.138h2.4v-2.28h2.25v.237h1.15-1.15zM1.9 8.455v-3.42c0-1.154.985-2.09 2.2-2.09h4.2v2.137H4.15v3.373H1.9zm0 2.137h2.25v3.325H8.3v2.138H4.1c-1.215 0-2.2-.936-2.2-2.09v-3.373zm15.05-2.137H14.7V5.082h-4.15V2.945h4.2c1.215 0 2.2.936 2.2 2.09v3.42z"/></svg>`
      },
      {
        name: 'stretched',
        icon: `<svg width="17" height="10" viewBox="0 0 17 10" xmlns="http://www.w3.org/2000/svg"><path d="M13.568 5.925H4.056l1.703 1.703a1.125 1.125 0 0 1-1.59 1.591L.962 6.014A1.069 1.069 0 0 1 .588 4.26L4.38.469a1.069 1.069 0 0 1 1.512 1.511L4.084 3.787h9.606l-1.85-1.85a1.069 1.069 0 1 1 1.512-1.51l3.792 3.791a1.069 1.069 0 0 1-.475 1.788L13.514 9.16a1.125 1.125 0 0 1-1.59-1.591l1.644-1.644z"/></svg>`
      },
      {
        name: 'withBackground',
        icon: `<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.043 8.265l3.183-3.183h-2.924L4.75 10.636v2.923l4.15-4.15v2.351l-2.158 2.159H8.9v2.137H4.7c-1.215 0-2.2-.936-2.2-2.09v-8.93c0-1.154.985-2.09 2.2-2.09h10.663l.033-.033.034.034c1.178.04 2.12.96 2.12 2.089v3.23H15.3V5.359l-2.906 2.906h-2.35zM7.951 5.082H4.75v3.201l3.201-3.2zm5.099 7.078v3.04h4.15v-3.04h-4.15zm-1.1-2.137h6.35c.635 0 1.15.489 1.15 1.092v5.13c0 .603-.515 1.092-1.15 1.092h-6.35c-.635 0-1.15-.489-1.15-1.092v-5.13c0-.603.515-1.092 1.15-1.092z"/></svg>`
      }
    ];
    const wrapper = document.createElement('div');

    settings.forEach( tune => {
      let button = document.createElement('div');

      button.classList.add('cdx-settings-button');
      button.innerHTML = tune.icon;
      wrapper.appendChild(button);
    });

    return wrapper;
  }
}
window.editorjs.SimpleImage = SimpleImage;


$(document).on('turbolinks:load', function () {
  if ($('#editorsection').length > 0) {
    const editor = new EditorJS({
      holder: 'editorsection',
      readOnly: false,
      tools: { 
        header: {
          class: Header, 
          placeholder: 'Enter a header',
          // inlineToolbar: ['link'],
          levels: [1, 2, 3],
          defaultLevel: 2
        }, 
        list: { 
          class: List, 
          inlineToolbar: true 
        }, 
        table: {
          class: Table,
        },
        marker: {
          class: Marker,
          shortcut: 'CMD+SHIFT+M',
        },
        delimiter: Delimiter,
      }, 
      data: {
        blocks: [
          {
            type: "header",
            id: 'myid',
            data: {
              id: 'myid',
              text: "Editor.js",
              level: 2
            }
          },
          {
            type : 'paragraph',
            data : {
              text : 'Hey. Meet the new Editor. On this page you can see it in action — try to edit this text. Source code of the page contains the example of connection and configuration.'
            }
          },
          {
            type: "header",
            data: {
              text: "Key features",
              level: 3
            }
          },
          {
            type : 'list',
            data : {
              items : [
                'It is a block-styled editor',
                'It returns clean data output in JSON',
                'Designed to be extendable and pluggable with a simple API',
              ],
              style: 'unordered'
            }
          },
          {
            type: "header",
            data: {
              text: "What does it mean «block-styled editor»",
              level: 3
            }
          },
          {
            type : 'paragraph',
            data : {
              text : 'Workspace in classic editors is made of a single contenteditable element, used to create different HTML markups. Editor.js <mark class=\"cdx-marker\">workspace consists of separate Blocks: paragraphs, headings, images, lists, quotes, etc</mark>. Each of them is an independent contenteditable element (or more complex structure) provided by Plugin and united by Editor\'s Core.'
            }
          },
          {
            type : 'paragraph',
            data : {
              text : `There are dozens of <a href="https://github.com/editor-js">ready-to-use Blocks</a> and the <a href="https://editorjs.io/creating-a-block-tool">simple API</a> for creation any Block you need. For example, you can implement Blocks for Tweets, Instagram posts, surveys and polls, CTA-buttons and even games.`
            }
          },
          {
            type: "header",
            data: {
              text: "What does it mean clean data output",
              level: 3
            }
          },
          {
            type : 'paragraph',
            data : {
              text : 'Classic WYSIWYG-editors produce raw HTML-markup with both content data and content appearance. On the contrary, Editor.js outputs JSON object with data of each Block. You can see an example below'
            }
          },
          {
            type : 'paragraph',
            data : {
              text : `Given data can be used as you want: render with HTML for <code class="inline-code">Web clients</code>, render natively for <code class="inline-code">mobile apps</code>, create markup for <code class="inline-code">Facebook Instant Articles</code> or <code class="inline-code">Google AMP</code>, generate an <code class="inline-code">audio version</code> and so on.`
            }
          },
          {
            type : 'paragraph',
            data : {
              text : 'Clean data is useful to sanitize, validate and process on the backend.'
            }
          },
          {
            type : 'delimiter',
            data : {}
          },
          {
            type : 'paragraph',
            data : {
              text : 'We have been working on this project more than three years. Several large media projects help us to test and debug the Editor, to make its core more stable. At the same time we significantly improved the API. Now, it can be used to create any plugin for any task. Hope you enjoy. 😏'
            }
          },
        ]
      },
      onReady: function(){
        saveButton.click();
      },
      onChange: function() {
        console.log('something changed');
      }
    });

    const saveButton = document.getElementById('saveButton');

    const toggleReadOnlyButton = document.getElementById('toggleReadOnlyButton');
    const readOnlyIndicator = document.getElementById('readonly-state');

    saveButton.addEventListener('click', function () {
      editor.save()
        .then((savedData) => {
          console.log(savedData);
          const edjsParser = edjsHTML();
          let html = edjsParser.parse(savedData);
          console.log(html);
        })
        .catch((error) => {
          console.error('Saving error', error);
        });
    });

    /**
     * Toggle read-only example
     */
    toggleReadOnlyButton.addEventListener('click', async () => {
      const readOnlyState = await editor.readOnly.toggle();

      readOnlyIndicator.textContent = readOnlyState ? 'On' : 'Off';
    });
  }
});